import { logoutUser } from "../apps/authSlice";
import baseApi from "../../api/baseApi"; // baseApi'yi import et

let lastAuthCheck = 0;
const CHECK_INTERVAL = 5000;

const authCheckMiddleware = (store) => (next) => async (action) => {
  // Hata yönetimi
  if (
    action.error &&
    (action.error.message.includes("401") ||
      action.error.message.includes("Network Error"))
  ) {
    window.location.reload();
    store.dispatch(logoutUser());
    return;
  }

  if (
    action.type.startsWith("auth/") ||
    action.type.startsWith("LayoutSlice/")
  ) {
    return next(action);
  }

  if (action.type.endsWith("/fulfilled")) {
    const now = Date.now();

    if (now - lastAuthCheck < CHECK_INTERVAL) {
      return next(action);
    }

    lastAuthCheck = now;

    try {
      const user = localStorage.getItem("authUser");

      if (user) {
        const data = JSON.parse(user);

        const authResult = await baseApi.get(`/Auth/AuthCheck`);

        const hasChangesRole = data.data.role !== authResult.data.result.role;
        const hasChangesUser =
          data.data.name !== authResult.data.result.name ||
          data.data.surname !== authResult.data.result.surname;

        if (hasChangesRole || authResult.status === 400) {
          store.dispatch(logoutUser());
          window.location.reload();
          return;
        } else if (hasChangesUser) {
          data.data.name = authResult.data.result.name;
          data.data.surname = authResult.data.result.surname;
          localStorage.setItem("authUser", JSON.stringify(data));
          return next(action);
        }
      } else {
        store.dispatch(logoutUser());
        window.location.reload();
      }
    } catch (error) {
      store.dispatch(logoutUser());
      window.location.reload();
      return;
    }
  }

  return next(action);
};

export default authCheckMiddleware;
